import { render, staticRenderFns } from "./receita-complementar.vue?vue&type=template&id=2b52b436&"
import script from "./receita-complementar.vue?vue&type=script&lang=js&"
export * from "./receita-complementar.vue?vue&type=script&lang=js&"
import style0 from "./receita-complementar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports